// @core/api/endpoints/calendar/book_slot.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookSlotRequest,
  BookSlotResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Book slot
 * Books a time slot through a booking link. Creates an event on the link owner's calendar with the booker as an attendee. This is a public endpoint.
 */
export async function BookSlot(
  slug: string,
  data: BookSlotRequest,
  options?: RequestOptions
): Promise<BookSlotResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/public/booking/:slug/book`;
  requestPath = requestPath.replace(':slug', encodeURIComponent(slug));
  const requestOptions = options;
  return client.post<BookSlotResponse>(requestPath, data, requestOptions);
}
